/**
 * @Author: 仙道
 * @Date: 2022-05-03 20:09:14
 * @LastEditTime: 2022-08-24 23:53:10
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/api/device.js
 **/
import { axios } from '@/utils/request'
export function iotAlertAck(parameter) {
  return axios({
    url: '/alert/iotAlert/ack',
    data: parameter,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
/** *****
 * @description: 获取供水流域列表
 * @param {*}
 * @return {*}
 */
export function selectDropList() {
  return axios({
    url: `/device/devAreaLocation/selectDropList`,
    method: 'get'
  })
}
/** *****
 * @description:设备工艺
 * @param {*}
 * @return {*}
 */
export function selectDevProcessList() {
  return axios({
    url: `/device/devProcess/list`,
    method: 'get'
  })
}

/** *****
 * @description:获取设备类型列表
 * @param {*}
 * @return {*}
 */
export function selectDevClassList() {
  return axios({
    url: `/device/devClass/selectDropList`,
    method: 'get'
  })
}

/** *****
 * @description: 设备详情新增top
 * @param {*}
 * @return {*}
 */
export function addDevList() {
  return axios({
    url: `/device/devList/add`,
    method: 'post'
  })
}
